import * as types from './actionTypes';

const initialState = {
  jobCodes: [],
  importList: [],
  importTemplateUrl: '',
  approveList: [],
  dropdownList: [],
  processList: [],
  assignList: [],
  applicantLevelDtls: [],
  loading: false,
  error: null,
  success: false,
};

const onboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ONBOARDING_JOB_CODE_REQUEST:
    case types.FETCH_ONBOARDING_IMPORT_LIST_REQUEST:
    case types.SAVE_ONBOARDING_APPLY_JOB_REQUEST:
    case types.FETCH_IMPORT_TEMPLATE_REQUEST:
    case types.UPLOAD_ONBOARDING_IMPORT_FILE_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_ONBOARDING_JOB_CODE_SUCCESS:
      return { ...state, loading: false, jobCodes: Array.isArray(action.payload.data?.recp_position) ? action.payload.data.recp_position : [] };

    case types.FETCH_ONBOARDING_IMPORT_LIST_SUCCESS:
      return { ...state, loading: false, importList: action.payload.data || [] };

    case types.SAVE_ONBOARDING_APPLY_JOB_SUCCESS:
    case types.UPLOAD_ONBOARDING_IMPORT_FILE_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.FETCH_IMPORT_TEMPLATE_SUCCESS:
      return { ...state, loading: false, importTemplateUrl: action.payload.data, success: false };

    case types.FETCH_ONBOARDING_JOB_CODE_FAILURE:
    case types.FETCH_ONBOARDING_IMPORT_LIST_FAILURE:
    case types.SAVE_ONBOARDING_APPLY_JOB_FAILURE:
    case types.FETCH_IMPORT_TEMPLATE_FAILURE:
    case types.UPLOAD_ONBOARDING_IMPORT_FILE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.FETCH_ONBOARDING_JOB_APPROVE_LIST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_ONBOARDING_JOB_APPROVE_LIST_SUCCESS:
      return { ...state, loading: false, approveList: action.payload, success: false };

    case types.FETCH_ONBOARDING_JOB_APPROVE_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.SAVE_ONBOARDING_JOB_APPROVE:
      return { ...state, loading: true, success: false };

    case types.SAVE_ONBOARDING_JOB_APPROVE_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.SAVE_ONBOARDING_JOB_APPROVE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.FETCH_ONBOARDING_DROPDOWN_LIST:
    case types.FETCH_ONBOARDING_PROCESS_LIST:
    case types.FETCH_ONBOARDING_PROCESS_ASSIGN_LIST:
    case types.CHANGE_ONBOARDING_PROCESS_STATUS:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.FETCH_ONBOARDING_DROPDOWN_LIST_SUCCESS:
      return { ...state, loading: false, dropdownList: action.payload,success: false };

    case types.FETCH_ONBOARDING_PROCESS_LIST_SUCCESS:
      return { ...state, loading: false, processList: action.payload,success: false };

    case types.FETCH_ONBOARDING_PROCESS_ASSIGN_LIST_SUCCESS:
      return { ...state, loading: false, assignList: action.payload,success: false };

    case types.CHANGE_ONBOARDING_PROCESS_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.FETCH_ONBOARDING_DROPDOWN_LIST_FAILURE:
    case types.FETCH_ONBOARDING_PROCESS_LIST_FAILURE:
    case types.FETCH_ONBOARDING_PROCESS_ASSIGN_LIST_FAILURE:
    case types.CHANGE_ONBOARDING_PROCESS_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case types.SAVE_ONBOARDING_SCHEDULING_PROCESS:
    case types.UPDATE_APPLICANTS_LEVELS_REQUEST:
    case types.FETCH_APPLICANT_LEVEL_DTLS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.SAVE_ONBOARDING_SCHEDULING_PROCESS_SUCCESS:
    case types.UPDATE_APPLICANTS_LEVELS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case types.FETCH_APPLICANT_LEVEL_DTLS_SUCCESS:
      return {
        ...state,
        loading: false,
        applicantLevelDtls: action.payload || [],
        success: false,
      };

    case types.SAVE_ONBOARDING_SCHEDULING_PROCESS_FAILURE:
    case types.UPDATE_APPLICANTS_LEVELS_FAILURE:
    case types.FETCH_APPLICANT_LEVEL_DTLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    default:
      return state;
  }
};

export default onboardingReducer;
